<template>
  <el-dialog
    title="搜索调拨单"
    :visible="visible"
    width="700px"
    append-to-body
    @close="$emit('update:show', false)"
  >
    <el-input v-model="query" placeholder="单号"></el-input>

    <el-table :data="list" size="small" class="mt-10">
      <el-table-column prop="order_number" label="调拨单号"> </el-table-column>
      <el-table-column prop="base.name" label="发起地/接收地">
        <template slot-scope="scope">
          {{ scope.row.well.well_number || scope.row.base.name }}<br />
          {{
            scope.row.receive_well.well_number || scope.row.approve_base.name
          }}
        </template>
      </el-table-column>

      <el-table-column align="center" label="操作" width="150">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            class="ml-5"
            @click="handleSelect(scope.row)"
            >选择</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import _ from 'lodash'
import { applyList } from '../../service/getData'
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    wellid: Number,
  },
  watch: {
    show() {
      this.visible = this.show
    },
    query() {
      this.debouncedGetSearch()
    },
  },
  data() {
    return {
      visible: false,
      query: '',
      list: [],
    }
  },
  created() {
    this.debouncedGetSearch = _.debounce(this.getApplyList, 200)
  },
  methods: {
    async getApplyList() {
      if (!this.query) {
        this.list = []
        return
      }

      let res = await applyList({
        order_number: this.query,
        size: 10,
        type: 2,
        status: 3,
        receive_well_id: this.wellid,
        approving: true,
      })
      this.list = res.data.list
    },

    handleSelect(item) {
      this.list = []
      this.query = ''
      this.$emit('selected', item)
      this.$emit('update:show', false)
    },
  },
}
</script>
